import { AlertDialogCloseButton } from "@chakra-ui/react";
import { ReactElement, ReactNode } from "react";
import { IoOpenOutline } from "react-icons/io5";

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogProps,
  Button,
} from "@meditect/medibase-components";

export interface DialogModalProperties extends Omit<AlertDialogProps, "children"> {
  buttonLabel?: ReactNode;
  cancelButtonLabel?: string;
  cancelRef?: React.Ref<HTMLButtonElement>;
  description: ReactNode;
  hasCloseButton?: boolean;
  icon?: ReactElement;
  isLoading?: boolean;
  onConfirm?: () => void;
  title: string;
}

export const DialogModal = ({
  buttonLabel = "Ouvrir",
  cancelButtonLabel = "Annuler",
  cancelRef,
  colorScheme = "info",
  description,
  hasCloseButton,
  icon = <IoOpenOutline />,
  isLoading,
  onConfirm,
  title,
  ...rest
}: DialogModalProperties): React.ReactElement => {
  return (
    <AlertDialog isCentered {...rest}>
      <AlertDialogOverlay>
        <AlertDialogContent m="2">
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title}
            {hasCloseButton ? <AlertDialogCloseButton /> : null}
          </AlertDialogHeader>
          <AlertDialogBody>{description}</AlertDialogBody>
          <AlertDialogFooter gap={3} justifyContent="start" width="full">
            {onConfirm ? (
              <Button
                colorScheme={colorScheme}
                data-testid="dialog-button-confirm"
                isLoading={isLoading}
                leftIcon={icon}
                onClick={onConfirm}
                width="50%"
              >
                {buttonLabel}
              </Button>
            ) : null}
            <Button colorScheme="gray" onClick={rest.onClose} ref={cancelRef} variant="outline" width="50%">
              {cancelButtonLabel}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
